import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { usePlayer } from '../hooks/usePlayer.js'
import { setPlayerLang } from '../api/levelApi.js'

/**
 * Guarda en el servidor el idioma de la app del jugador para que los avisos
 * push le lleguen en su idioma (api/push_texts.py). Se manda al entrar y cada
 * vez que cambia de idioma; una vez por sesión y combinación usuario/idioma.
 */
export default function LangSync() {
  const { i18n } = useTranslation()
  const { session } = usePlayer()
  const userId = session?.user?.id
  const lang = (i18n.language || '').slice(0, 2)

  useEffect(() => {
    if (!userId || !lang) return
    const key = `nivela_lang_sent:${userId}:${lang}`
    try { if (sessionStorage.getItem(key)) return } catch { /* sin almacenamiento */ }
    setPlayerLang(lang)
      .then(() => { try { sessionStorage.setItem(key, '1') } catch { /* ignore */ } })
      .catch(() => { /* se reintenta en la siguiente carga */ })
  }, [userId, lang])

  return null
}
